// Fallback for courses without a provider image.
export const GOLF_DEFAULT_COURSE_IMAGE_URL = '/static/golf-course-default.jpg';
